import dayjs from "dayjs";
import cloneDeep from "lodash/cloneDeep";

export enum SplitChannels {
    ORGANIC_SEARCH = "Organic Search",
    PAID_SEARCH = "Paid Search",
    SEARCH = "Search",
    JUNE2020 = "2020-06-02",
}
const dateFormatter = (date) => date.replaceAll("|", "-");
export const isDurationAfterSplit = (date) => {
    const changedFormat = dateFormatter(date);
    return dayjs(changedFormat).isAfter(SplitChannels.JUNE2020);
};
export const isRemoveSplitPopSingle = (from, compareFrom, data, params) => {
    let newData = { ComparedData: {}, Data: {} };
    newData = cloneDeep(data);
    const duration = minDate(from, compareFrom);
    if (!isDurationAfterSplit(duration)) {
        delete newData.ComparedData[params.key][SplitChannels.ORGANIC_SEARCH];
        delete newData.Data[params.key][SplitChannels.ORGANIC_SEARCH];
        delete newData.Data[params.key][SplitChannels.PAID_SEARCH];
        delete newData.ComparedData[params.key][SplitChannels.PAID_SEARCH];
    } else {
        delete newData.ComparedData[params.key][SplitChannels.SEARCH];
        delete newData.Data[params.key][SplitChannels.SEARCH];
    }
    return newData;
};
export const isRemoveSplitPopCompare = (from, compareFrom, data, chosenSites) => {
    let newData = { ComparedData: {}, Data: {} };
    newData = cloneDeep(data);
    const duration = minDate(from, compareFrom);
    if (!isDurationAfterSplit(duration)) {
        chosenSites.map((key) => {
            delete newData.Data[key][SplitChannels.ORGANIC_SEARCH];
            delete newData.ComparedData[key][SplitChannels.ORGANIC_SEARCH];
            delete newData.Data[key][SplitChannels.PAID_SEARCH];
            delete newData.ComparedData[key][SplitChannels.PAID_SEARCH];
        });
    } else {
        chosenSites.map((key) => {
            if (newData.ComparedData[key]) {
                delete newData.ComparedData[key][SplitChannels.SEARCH];
            }
            if (newData.Data[key]) {
                delete newData.Data[key][SplitChannels.SEARCH];
            }
        });
    }
    return newData;
};


type WithBreakDown = {
    BreakDown?: Record<string, Record<string, unknown>>;
};

export const removeDataFromGraphData = <T extends WithBreakDown>(
    data: T,
    fromDate: string,
): T => {
    if (!data?.BreakDown || typeof data.BreakDown !== "object") {
        return data;
    }

    const newData = cloneDeep(data);

    if (!dayjs(fromDate).isAfter(SplitChannels.JUNE2020)) {
        Object.keys(newData.BreakDown).forEach((date) => {
            delete newData.BreakDown?.[date]?.[SplitChannels.ORGANIC_SEARCH];
            delete newData.BreakDown?.[date]?.[SplitChannels.PAID_SEARCH];
        });
    } else {
        Object.keys(newData.BreakDown).forEach((date) => {
            delete newData.BreakDown?.[date]?.[SplitChannels.SEARCH];
        });
    }

    return newData;
};

export const minDate = (date1, date2) => {
    return dayjs(dateFormatter(date1)).isBefore(dayjs(dateFormatter(date2))) ? date1 : date2;
};
export const removeSplitSearchChannels = (activeChannels) => {
    return activeChannels.filter((item) => item !== SplitChannels.ORGANIC_SEARCH && item !== SplitChannels.PAID_SEARCH);
};
export const removeSearchChannel = (activeChannels) => {
    return activeChannels.filter((item) => item !== SplitChannels.SEARCH);
};
export const removeSearchChannelTotal = (activeChannels) => {
    return activeChannels.filter((item) => item.name !== SplitChannels.SEARCH);
};
export const removeSplitSearchChannelsTotal = (activeChannels) => {
    return activeChannels.filter(
        (item) => item.name !== SplitChannels.ORGANIC_SEARCH && item.name !== SplitChannels.PAID_SEARCH,
    );
};
